
import Vue from "vue";
import { Menu } from "@ambii-com/core";

export default Vue.extend({
  props: {
    menu: Menu,
    dark: Boolean,
    chipContainerWidth: Number,
    hasMargin: {
      type: Boolean,
      default: false,
    },
  },
  data(): {
    locale: string;
  } {
    return {
      locale: this.$i18n.locale,
    };
  },
  computed: {
    chipColor(): string {
      return this.dark ? "white" : "secondaryLighter";
    },
    chipStyle(): object {
      return {
        maxWidth: `${this.chipContainerWidth * 0.88}px`,
      };
    },
  },
});
